import { Config } from '@const/url'
import { axiosInstance } from './axios'

const getRequest = async (URL: string, signal?: AbortSignal): Promise<any> =>
  await axiosInstance({
    method: 'get',
    url: URL,
    headers: Config.HEADERS,
    signal,
  })

const getRequestFile = async (URL: string, options: any, signal?: AbortSignal): Promise<any> =>
  await axiosInstance({
    method: 'get',
    url: URL,
    headers: Config.HEADERS,
    signal,
    ...options,
  })

const postRequest = async (
  URL: string,
  headers: any,
  data?: any,
  signal?: AbortSignal
): Promise<any> =>
  await axiosInstance({
    method: 'post',
    url: URL,
    headers: {
      ...Config.HEADERS,
      ...headers,
    },
    data,
    signal,
  })

const putRequest = async (
  URL: string,
  headers: any,
  data?: any,
  signal?: AbortSignal
): Promise<any> =>
  await axiosInstance({
    method: 'put',
    url: URL,
    headers: { ...Config.HEADERS, ...headers },
    data,
    signal,
  })

const patchRequest = async (
  URL: string,
  headers: any,
  data?: any,
  signal?: AbortSignal
): Promise<any> =>
  await axiosInstance({
    method: 'patch',
    url: URL,
    headers: { ...Config.HEADERS, ...headers },
    data,
    signal,
  })

const deleteRequest = async (URL: string, signal?: AbortSignal): Promise<any> =>
  await axiosInstance({
    method: 'delete',
    url: URL,
    headers: Config.HEADERS,
    signal,
  })

export {
  axiosInstance,
  deleteRequest,
  getRequest,
  getRequestFile,
  patchRequest,
  postRequest,
  putRequest,
}
